import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';


import localStorageHelper from 'utils/localStorageHelper';

const styles = theme => ({
    userMenuButton: {
        margin: 5
    },

    link: theme.style.link
});

class NavBarUserMenu extends React.Component {

    state = {
        anchorEl: null
    };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ anchorEl: null });
    };


    administrer = event => {
        this.setState({ anchorEl: "administrer" });
    };


    render() {

        const { classes } = this.props;
        const { anchorEl } = this.state;


        // Il faut cacher le bouton d'administration si l'utilisateur n'est pas administrateur.
        let afficheBoutonAdministration = localStorageHelper.afficheBoutonAdministration();


        return (
            <div>
                <IconButton
                    color="inherit"
                    className={classes.userMenuButton}
                    onClick={this.handleClick}
                    size="large">
                    <MoreVertIcon />
                </IconButton>

                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.handleClose}>

                    {
                        afficheBoutonAdministration &&
                        <Link to="/administration" className={classes.link}>
                            <MenuItem onClick={this.handleClose}>
                                <ListItemIcon>
                                    <SettingsIcon />
                                </ListItemIcon>
                                <ListItemText primary="Administration" />
                            </MenuItem>
                        </Link>
                    }

                    <Link to="/login" className={classes.link}>
                        <MenuItem onClick={this.props.logout}>
                            <ListItemIcon>
                                <PowerSettingsNewIcon />
                            </ListItemIcon>
                            <ListItemText primary="Déconnexion" />
                        </MenuItem>
                    </Link>
                </Menu>
            </div>
        );
    }
}

NavBarUserMenu.propTypes = {
    classes: PropTypes.object.isRequired,
    logout: PropTypes.func.isRequired
};

export default withStyles(styles)(NavBarUserMenu);
